import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
const {
  Page
} = lazyImport(() => import('../index'), 'Page');
export const routes = [{
  name: '404',
  path: '*',
  element: /*#__PURE__*/React.createElement(Page, null),
  enable: true
}];